import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Forms.css";

/** Signup form.
 *
 * Shows form and manages update to state on changes.
 * On submission:
 * - calls signup function prop
 * - redirects to /spaces route
 *
 * Routes -> SignupForm
 * Routed as /signup
 */

function SignupForm({ signup }) {
  const navigate = useNavigate();

  const INITIAL_STATE = {
    username: "",
    email: "",
    password: "",
    firstName: "",
    lastName: "",
  };
  const [formData, setFormData] = useState(INITIAL_STATE);

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setFormData((data) => ({ ...data, [name]: value }));
  };

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    const { username, email, password, firstName, lastName } = formData;
    try {
      await signup({ username, email, password, firstName, lastName });
      navigate("/spaces");
      setFormData(INITIAL_STATE);
    } catch (error) {
      console.error("Registration failed", error);
    }
  };

  console.debug("SignupForm", "signup=", typeof signup, "formData=", formData);

  return (
    <div className="form-page">
      <div className="form-card">
        <h1 className="form-card-title">Create Account</h1>
        <p className="form-card-subtitle">Join Bells+Whistles to explore our portfolio</p>

        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label className="form-label" htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
            />
          </div>

          <div className="form-field">
            <label className="form-label" htmlFor="password">Password</label>
            <input
              type="password"
              name="password"
              id="password"
              value={formData.password}
              onChange={handleChange}
            />
          </div>

          <div className="form-field">
            <label className="form-label" htmlFor="firstName">First Name</label>
            <input
              type="text"
              name="firstName"
              id="firstName"
              value={formData.firstName}
              onChange={handleChange}
            />
          </div>

          <div className="form-field">
            <label className="form-label" htmlFor="lastName">Last Name</label>
            <input
              type="text"
              name="lastName"
              id="lastName"
              value={formData.lastName}
              onChange={handleChange}
            />
          </div>

          <div className="form-field">
            <label className="form-label" htmlFor="email">Email</label>
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <button className="form-submit-btn" type="submit">Create Account</button>
        </form>

        <p className="form-footer-text">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}

export default SignupForm;
